// contexts/AccessTokenContext.jsx
import React, { createContext, useState, useEffect, useMemo, useContext, useSyncExternalStore } from 'react'
import { UserAuthApi } from '@/apis/v2/UserAuthApi';
import { getMemoryAccessToken, memoryAccessToken, setMemoryAccessToken, subscribeMemoryAccessToken } from '@/storages/authStorage';

const AuthValueContext = createContext();
const AuthActionsContext = createContext();

export function AuthContextProvider({ children }) {
    const accessToken = useSyncExternalStore(
        subscribeMemoryAccessToken,  // 구독 함수
        getMemoryAccessToken,   // 값 가져오는 함수
        () => memoryAccessToken // 서버 스냅샷 함수 (SSR 시)
    );
    const [isReady, setReady] = useState(false)

    useEffect(() => {
        (async () => {
            try {
                const token = await UserAuthApi.reissueAccessToken()
                setMemoryAccessToken(token)
            } catch {
                setMemoryAccessToken(null);
            } finally {
                setReady(true)
            }
        })()
    }, []);

    const actions = useMemo(() => {
        return {
            login(accessToken) {
                setMemoryAccessToken(accessToken);
            },
            logout() {
                setMemoryAccessToken(null);
            },
            setReady(bool) {
                setReady(bool);
            }
        }
    }, []);
    return (
        <AuthActionsContext.Provider value={actions}>
            <AuthValueContext.Provider value={{ isLoggedIn: !!accessToken, isReady, accessToken }}>
                {children}
            </AuthValueContext.Provider>
        </AuthActionsContext.Provider >
    )
}

export function useAuthContextValueHook() {
    const value = useContext(AuthValueContext);

    if (value === undefined) {
        throw new Error('useAuthContextValueHook should be used within AuthContextProvider');
    }

    return {
        isLoggedIn: value.isLoggedIn,
        isReady: value.isReady,
        accessToken: value.accessToken
    };
}

export function useAuthContextActionsHook() {
    const value = useContext(AuthActionsContext);

    if (value === undefined) {
        throw new Error('useAuthContextActionsHook should be used within AuthContextProvider');
    }

    return {
        login: value.login,
        logout: value.logout,
        setReady: value.setReady
    };
}